import { ROUTE_NAMES } from '../../../router/RouterApp';
import { BUSINESS_LINES } from '../../interface/IPayload';

/**
 * Default options for DK-date format
 */
const defaultOptions: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
};

export function convertPxToRem(fontSize: number): string {
    const baseFontSize = 16;
    return `${fontSize / baseFontSize}rem`;
}

export function getStepCount(): number {
    return Object.keys(ROUTE_NAMES).length;
}

export function removeLastSlash(routeName: ROUTE_NAMES | string): string {
    return routeName.replace(/\//g, '');
}

/**
 * PAJ - Scroll to a absolute Y axis postion in window
 * Fix for auto-scroll - Mobile screens - US 119415
 * @param offset number - offset by a number
 * @param behavior 'smooth' | 'auto' - behavior by 'smooth' | 'auto'
 */
export const scrollToWindowYPosition = (offset: number, behavior: 'smooth' | 'auto') => {
    window.scrollTo({
        top: offset,
        behavior: behavior,
    });
};

export function getFullPathName(baseName: string, routeName: string, withLastSlash: boolean) {
    const baseNameWithoutLastSlash = baseName.replace(/\/$/g, '');
    return withLastSlash ? `${baseNameWithoutLastSlash}${routeName}/` : `${baseNameWithoutLastSlash}${routeName}`;
}

export const formatInt = (i: number) => {
    // cast to string and remove non digits
    const str = i.toString().replace(/[^0-9]/g, '');
    return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(+str);
};

/**
 * Converts a formatted string '2020-05-14' to '14. maj 2020'
 */
export const dateStr = (date: string, options?: object): string => {
    if (!date) return date;
    const dateObj = new Date(date);
    const opt = options || defaultOptions;
    return dateObj.toLocaleDateString('da-DK', opt);
};

export const str2float = (str: string): number => {
    if (!str) return 0; // Maybe not a good idea!
    str = str.replace(/\./g, '').replace(',', '.');
    return parseFloat(str) || 0;
};

export const vanInsuranceValue = (businessLine: string, van: undefined | boolean) => {
    if (businessLine === BUSINESS_LINES.OFFICE_WORK) {
        return 'N/A';
    } else if (van) {
        return 'Ja';
    } else {
        return 'Nej';
    }
};
